import { render, staticRenderFns } from "./RcvScLPrice_List.vue?vue&type=template&id=1ac3e90f"
import script from "./RcvScLPrice_List.vue?vue&type=script&lang=js"
export * from "./RcvScLPrice_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports